module.exports = __webpack_public_path__ + "static/mellon_bank-9854688efd71895cd6d8623423d921fb.png";